import {mapMutations, mapGetters} from "vuex";

export default {
    name: "register-success",
    data() {
        return {
            isRegister: false
        }
    },
    methods: {
        ...mapMutations({
            changeShowPopUpLogin: 'auth/CHANGE_POPUP_LOGIN',
            changeShowPopUpPasswordRecovery: 'auth/CHANGE_POPUP_PASSWORD_RECOVERY',
            changeShowPopUpPasswordEmail: 'auth/CHANGE_POPUP_PASSWORD_EMAIL',
            changeShowPopUpRegisterSuccess: 'auth/CHANGE_POPUP_REGISTER_SUCCESS'
        }),
        goToUserAccount() {
            this.changeShowPopUpPasswordRecovery(false)
            this.changeShowPopUpPasswordEmail(false)
            this.changeShowPopUpRegisterSuccess(false)
            this.$router.push({name: 'user'}).then(() => {
                this.removeProducts()
            }).catch(() => {
                console.log();
            });

        },
        goToCatalog() {
            this.changeShowPopUpPasswordRecovery(false)
            this.changeShowPopUpPasswordEmail(false)
            this.changeShowPopUpRegisterSuccess(false)
            this.$router.push({name: 'catalog'}).then(() => {
                this.removeProducts()
            }).catch(() => {
                console.log();
            });

        }
    },
    computed: {
        ...mapGetters({
            showPopUpPasswordRecovery: `auth/showPopUpPasswordRecovery`,
            showPopUpPasswordEmail: `auth/showPopUpPasswordEmail`,
            showPopUpRegisterSuccess: `auth/showPopUpRegisterSuccess`,
            removeProducts: 'auth/DELETE_PRODUCTS'
        }),
    }
}

